import React from "react";
import ModalNew from "./Modal";
import PopupHeader from "./common/popupHeader";
import PopupContent from "./common/PopupContent";

function ValidationErrorsPopup({ isOpen, onClose, errors }) {
  if (!isOpen) return null;

  return (
    <ModalNew className="content-modal" style={{ maxWidth: "480px" }}>
      <PopupHeader
        title="Validation Errors"
        setOpenState={onClose}
        icon={`${process.env.PUBLIC_URL}/images/icons/validation_blue_popup.svg`}
        variant="compact"
      />
      <PopupContent>
        <div style={{ display: "grid", gap: "20px" }}>
          {errors.personalInfo && errors.personalInfo.length > 0 && (
            <div>
              <h3 className="section-card-title">Personal Information</h3>
              <ul style={{ margin: "8px 0 0 0", paddingLeft: "20px" }}>
                {errors.personalInfo.map((error, index) => (
                  <li key={index}>
                    <p style={{ margin: 0 }}>{error}</p>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {errors.address && errors.address.length > 0 && (
            <div>
              <h3 className="section-card-title">Address</h3>
              <ul style={{ margin: "8px 0 0 0", paddingLeft: "20px" }}>
                {errors.address.map((error, index) => (
                  <li key={index}>
                    <p style={{ margin: 0 }}>{error}</p>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {errors.socialMedia && errors.socialMedia.length > 0 && (
            <div>
              <h3 className="section-card-title">Social Media</h3>
              <ul style={{ margin: "8px 0 0 0", paddingLeft: "20px" }}>
                {errors.socialMedia.map((error, index) => (
                  <li key={index}>
                    <p style={{ margin: 0 }}>{error}</p>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div className="modal-actions" style={{ justifyContent: "center" }}>
            <button
              type="button"
              className="cta-button primary"
              onClick={() => onClose(false)}
            >
              Close
            </button>
          </div>
        </div>
      </PopupContent>
    </ModalNew>
  );
}

export default ValidationErrorsPopup;
